import React from 'react';
import { Card } from './ui/Card';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'The educational approach was exactly what I needed. Instead of empty promises, I got a clear plan to manage my utilization and build better habits.',
    author: 'Sarah M.',
    role: 'Small Business Owner'
  }, {
    quote: 'I finally understand how my credit profile works. The consultation was professional, transparent, and completely pressure-free.',
    author: 'James T.',
    role: 'Consulting Client'
  }, {
    quote: 'DanyCredit helped me prepare for my mortgage application by explaining exactly what lenders look for. Highly recommended for the clarity alone.',
    author: 'Elena R.',
    role: 'Homebuyer'
  }];
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-166">
      {testimonials.map((item, idx) => <Card key={idx} className="p-6 bg-slate-50 border-none" data-id="element-167">
          <div className="flex mb-4" data-id="element-168">
            {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 text-yellow-400 fill-current" data-id="element-169" />)}
          </div>
          <p className="text-slate-700 italic mb-6 leading-relaxed" data-id="element-170">
            "{item.quote}"
          </p>
          <div data-id="element-171">
            <p className="font-semibold text-slate-900" data-id="element-172">{item.author}</p>
            <p className="text-sm text-slate-500" data-id="element-173">{item.role}</p>
          </div>
        </Card>)}
    </div>;
}